export const ShipmentPackageAllTR={
ShPaID:{en:'Package ID',cs:'ShPaID',dataType:'number',format:'#0',required:true},
ShPaType:{en:'Type',cs:'Typ',dataType:'string',required:true,maxLength:50},
ShPaCount:{en:'Pieces',cs:'Ks',dataType:'number',format:'#0',required:true},
ShPaKg:{en:'Weight (kg)',cs:'Kg',dataType:'number',format:'#0',required:true},
ShPaSize:{en:'Dimensions',cs:'Rozměr',dataType:'string',maxLength:1020},
ShPaRemark:{en:'Remark',cs:'Poznámka',dataType:'string',maxLength:1020},
ShPaTimeStamp:{en:'ShPaTimeStamp',cs:'ShPaTimeStamp',dataType:'number',format:'#0'},
ShipNumber:{en:'Shipment Number',cs:'Číslo přepravy',dataType:'string',maxLength:50},
ShipShStID:{en:'Status',cs:'Stav',dataType:'number',format:'#0'},
ShPaShRoID:{en:'ShPaShRoID',cs:'ShPaShRoID',dataType:'number',format:'#0',required:true},
ShRoShipID:{en:'ShRoShipID',cs:'ShRoShipID',dataType:'number',format:'#0'},
ShPaCountRemark:{en:'ShPaCountRemark',cs:'ShPaCountRemark',dataType:'string',maxLength:255}
}